import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { handoverQueryKeys } from '../constants/queryKeys';
import { consolidateHandovers } from '../service/consolidateHandovers';

export const useHandoverReconciliationSync = (enabled: boolean) => {
  const queryClient = useQueryClient();
  const hasSynced = useRef(false);

  useEffect(() => {
    if (!enabled || hasSynced.current) return;

    hasSynced.current = true;

    consolidateHandovers().then((data) => {
      if (!data) return;
      queryClient.setQueriesData({ queryKey: handoverQueryKeys.allMyHandovers }, data);
    });
  }, [enabled, queryClient]);
};
